import "../App.css";
import axios from "axios";
import { QuestionIcon } from "@primer/octicons-react";
import { useFormik } from "formik";
import * as yup from "yup";
import ReactTooltip from "react-tooltip";
import { useEffect, useState } from "react";
import Dropdown from "react-bootstrap/Dropdown";
import ReCAPTCHA from "react-google-recaptcha";
import CustomModal from "./CustomModal";
import MetaTags from "./MetaTag";

window.recaptchaOptions = {
  removeOnUnmount: true,
};
const grecaptchaObject = window.grecaptcha;

let widgetId = null;
export default function Signup() {
  const [emailError, setEmailError] = useState("");
  const [refVal, setRefVal] = useState("");
  const [isSignUpReCaptchaDone, setIsSignUpReCaptchaDone] = useState(false);
  const [showPopup, setShowPopup] = useState({ title: "", is: false, msg: "" });
  const [selectAccountType, setSelectAccountType] = useState(false);
  const [promoterReferralId, setPromoterReferralId] = useState(null);

  useEffect(() => {
    const getReferralId = () => {
      const cookies = document.cookie.split("; ").reduce((acc, cookie) => {
        const [key, value] = cookie.split("=");
        acc[key] = decodeURIComponent(value);
        return acc;
      }, {});
      return cookies["referralId"] || null;
    };

    setPromoterReferralId(getReferralId());
  }, []);

  const handlePopupClose = () => {
    if (showPopup?.location !== undefined) {
      window.location = showPopup?.location;
    }

    setShowPopup({
      ...showPopup,
      title: "",
      is: false,
      msg: "",
    });
  };
  const [referralMenuItems] = useState([
    { value: "Google", text: "Google" },
    { value: "Friend", text: "Friend" },
    { value: "Casual Fridays REI", text: "Casual Fridays REI" },
    { value: "RETipster", text: "RETipster" },
    {
      value: "Land Investing Motivation Mastermind",
      text: "Land Investing Motivation Mastermind",
    },
    { value: "Facebook", text: "Facebook" },

    { value: "Paperstac", text: "Paperstac" },
    { value: "Jaz Land", text: "Jaz Land" },
    { value: "Land Profit Generator", text: "Land Profit Generator" },
    { value: "OTHER", text: "Other" },
  ]);

  useEffect(() => {
    const referer = sessionStorage?.getItem("referer");
    if (refVal === "" && referer !== undefined && referer !== null) {
      const temp = referralMenuItems.filter((row) =>
        referer.includes((row?.value).toLowerCase())
      );
      if (temp.length) {
        setRefVal(temp[0].value);
      } else {
        setRefVal("OTHER");
      }
    }
  }, [refVal, referralMenuItems]);

  const phoneRegExp =
    /^(\+1|1)?[-.\s]?(\(\d{3}\)|\d{3})[-.\s]?\d{3}[-.\s]?\d{4}$/;

  const validationSchema = yup.object({
    userEmail: yup
      .string()
      .email("Enter Valid email Address")
      .required("Email is required"),
    firstName: yup.string().required("First Name is required"),
    lastName: yup.string().required("Last Name is required"),
    businessName: yup.string().required("Business Name is required"),
    phoneNumber: yup
      .string()
      .required("Phone number is required")
      .matches(phoneRegExp, "Phone number is not valid"),
    otherReferralSource: yup
      .string()
      .max(60, "Referral Source must be at most 60 characters"),
  });

  const formik = useFormik({
    initialValues: {
      firstName: "",
      lastName: "",
      userEmail: "",
      businessName: "",
      phoneNumber: "",
      referralSource: refVal,
      otherReferralSource: "",
      isConfirmLenderAccount: false,
      captcha_token: "",
    },
    validationSchema,
    onSubmit: (formValues) => {
      lenderSignUp(formValues);
    },
  });

  const {
    touched,
    errors,
    getFieldProps,
    handleBlur,
    handleSubmit,
    values,
    handleChange,
    setSubmitting,
    setFieldValue,
  } = formik;

  const newsLetter = (lenderdata) => {
    axios(`${process.env.REACT_APP_SIGNUP_URL}`, {
      method: "POST",
      headers: {
        "content-type": "application/json",
      },
      data: {
        newsletterSignup: {
          firstName: lenderdata.firstName,
          lastName: lenderdata.lastName,
          userEmail: lenderdata.userEmail?.toLowerCase(),
        },
      },
    })
      .then(async (res) => {
        window.location = "/ConfirmationPage";
      })
      .catch(async (error) => {
        setShowPopup({
          ...showPopup,
          title: "Alert",
          is: true,
          msg: error?.response?.data?.message,
          location: "/ConfirmationPage",
        });
      });
  };
  function formatPhoneNumberForAPI(phoneNumber) {
    const cleanedNumber = phoneNumber.replace(/\D/g, "");
    return cleanedNumber.startsWith("1")
      ? `+${cleanedNumber}`
      : `+1${cleanedNumber}`;
  }

  const lenderSignUp = (lenderdata) => {
    axios(`${process.env.REACT_APP_SIGNUP_URL}`, {
      method: "POST",
      headers: {
        "content-type": "application/json",
      },
      data: {
        userSignup: {
          ...(promoterReferralId ? { referralId: promoterReferralId } : {}),
          firstName: lenderdata.firstName,
          lastName: lenderdata.lastName,
          userEmail: lenderdata.userEmail?.toLowerCase(),
          businessName: lenderdata.businessName,
          captchaToken: lenderdata.captcha_token,
          phoneNumber: formatPhoneNumberForAPI(lenderdata?.phoneNumber) || "",
          referralSource:
            lenderdata.referralSource === "OTHER"
              ? `${lenderdata.referralSource}#${lenderdata.otherReferralSource}`
              : lenderdata.referralSource,
        },
      },
    })
      .then(async () => {
        document.cookie = "referralId=; Path=/; Max-Age=0";
        if (!lenderdata.userEmail?.includes("+")) {
          newsLetter(lenderdata);
        } else {
          window.location = "/ConfirmationPage";
        }
        setSubmitting(false);
        sessionStorage.clear();
      })
      .catch(async (error) => {
        if (
          error?.response?.data?.message ===
          `You can not use ${formik.values.userEmail} to create a Lender Account, Please try a different email`
        ) {
          setEmailError(error?.response?.data?.message);
          setShowPopup({
            ...showPopup,
            title: "Alert",
            is: true,
            msg: "Email already in use. Please try another email",
          });
          setSubmitting(false);
        } else {
          setShowPopup({
            ...showPopup,
            title: "Alert",
            is: true,
            msg: error?.response?.data?.message?.includes(
              "Lender profile with this email already exis"
            )
              ? "A lender profile with this email already exists"
              : error?.response?.data?.message,
          });
          setSubmitting(false);
        }
      });
  };

  const verifyCallback = (value) => {
    if (value) {
      formik.setFieldValue("captcha_token", value);
      setIsSignUpReCaptchaDone(true);
    }
  };

  const expiredRecaptcha = () => {
    console.log("expired");
    // widgetId.reset("captcha");
    if (widgetId !== null) {
      window.grecaptcha.reset(widgetId); // Reset reCAPTCHA without reloading
    }
    setIsSignUpReCaptchaDone(false);
  };

  const createRecaptcha = () => {
    window.grecaptcha?.ready(function () {
      widgetId = window.grecaptcha.render("captchaSignup", {
        sitekey: process.env.REACT_APP_RECAPTCHA_SITE_KEY,
        callback: verifyCallback,
        "expired-callback": expiredRecaptcha,
        "error-callback": function (e) {
          setIsSignUpReCaptchaDone(false);
        },
      });
    });
  };

  const hideRechaptcha =
    window.location.origin.includes("dev") ||
    window.location.origin.includes("localhost");

  const handleAccountType = (type) => {
    setSelectAccountType(type);
    if (type === "lender" && !hideRechaptcha) {
      createRecaptcha();
    }
  };
  function formatPhoneNumber(phoneNumber) {
    const cleaned = `${phoneNumber}`.replace(/\D/g, "");
    let formatted = cleaned;
    if (cleaned.length === 11 && cleaned[0] === "1") {
      formatted = cleaned.slice(1); // Remove the leading '1'
    }
    if (formatted.length === 10) {
      const match = formatted.match(/^(\d{3})(\d{3})(\d{4})$/);
      if (match) {
        return `(${match[1]}) ${match[2]}-${match[3]}`;
      }
    }
    return phoneNumber;
  }
  return (
    <div
      className="row py-4 overflow-hidden g-0"
      style={{ minHeight: "calc(100vh - 228px)", marginTop: "5.5rem" }}
    >
      <MetaTags
        title="Sign Up for Terra Notes - Simplified Real Estate Loan Servicing & Note Management Software"
        description="Join Terra Notes today for streamlined real estate loan servicing and note management. Sign up and start automating your portfolio with our easy-to-use software."
        url={`${process.env.REACT_APP_BASE_URL}/Signup`}
        image={`${process.env.REACT_APP_BASE_URL}/link-preview.png`}
      />

      <div className="col-md-4 px-4  d-none  d-lg-block">
        <div className="card shadow-md border-0 rounded-3 h-100 card-body position-relative">
          <h2 className=" text-center position-absolute top-50 start-50 translate-middle">
            Welcome to <br /> Terra Notes!
            <img
              src="/link-preview.png"
              alt="Logo"
              className="mt-3"
              style={{ width: "35vh" }}
            />
          </h2>
        </div>
      </div>

      {selectAccountType === "lender" ? (
        <div className=" offset-lg-1 col-lg-6 px-md-5 px-3 ">
          <div className="card-header text-center justify-content-center">
            <h3 className="text-success my-4">CREATE LENDER ACCOUNT</h3>
          </div>
          <div className="card-body">
            <form onSubmit={handleSubmit}>
              <div className="mb-3">
                <label className="mb-1 custom-required">Email</label>
                <input
                  className="form-control my-1"
                  id="userEmail"
                  type="email"
                  aria-describedby="emailHelp"
                  placeholder="JohnSmith@AwesomeLandCompany.com"
                  {...getFieldProps("userEmail")}
                  value={values.userEmail}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  // error={touched.userEmail && Boolean(errors.userEmail)}
                  // helpertext={touched.userEmail && errors.userEmail}
                />
                {touched.userEmail && errors.userEmail ? (
                  <div className="text-danger small">{errors.userEmail}</div>
                ) : emailError ===
                  `You can not use ${values.userEmail} to create a Lender Account, Please try a different email` ? (
                  <div className="text-danger small">Email already in use.</div>
                ) : null}
              </div>
              <div className="row gx-3">
                <div className="col-md-6 mb-2">
                  <label className="mb-1 custom-required">First Name</label>
                  <input
                    className="form-control my-1 is-validated"
                    id="firstName"
                    type="text"
                    placeholder="John"
                    {...getFieldProps("firstName")}
                    value={values.firstName}
                    onChange={handleChange}
                    onBlur={handleBlur}
                  />
                  {touched.firstName && errors.firstName ? (
                    <div className="text-danger small">{errors.firstName}</div>
                  ) : null}
                </div>
                <div className="col-md-6 mb-2">
                  <label className="mb-1 custom-required">Last Name</label>
                  <input
                    className="form-control my-1"
                    id="lastName"
                    type="text"
                    placeholder="Smith"
                    {...getFieldProps("lastName")}
                    value={values.lastName}
                    onChange={handleChange}
                    onBlur={handleBlur}
                  />
                  {touched.lastName && errors.lastName ? (
                    <div className="text-danger small">{errors.lastName}</div>
                  ) : null}
                </div>
                <div className="col-md-6 mb-2">
                  <label className="mb-1 custom-required">Phone Number</label>
                  <input
                    className="form-control my-1"
                    id="phoneNumber"
                    type="tel"
                    placeholder="(123) 456-7890"
                    {...getFieldProps("phoneNumber")}
                    value={formatPhoneNumber(values.phoneNumber)}
                    onChange={(e) => {
                      const rawValue = e.target.value.replace(/\D/g, "");
                      setFieldValue("phoneNumber", rawValue);
                    }}
                    onBlur={handleBlur}
                  />
                  {touched.phoneNumber && errors.phoneNumber ? (
                    <div className="text-danger small">
                      {errors.phoneNumber}
                    </div>
                  ) : null}
                </div>
                <div className="col-md-6 mb-2">
                  <label className="mb-1 custom-required">Business Name</label>
                  <input
                    className="form-control my-1"
                    id="businessName"
                    type="text"
                    placeholder="Awesome Land Company, LLC"
                    {...getFieldProps("businessName")}
                    value={values.businessName}
                    onChange={handleChange}
                    onBlur={handleBlur}
                  />
                  {touched.businessName && errors.businessName ? (
                    <div className="text-danger small">
                      {errors.businessName}
                    </div>
                  ) : null}
                </div>
              </div>

              <div className="row gx-3">
                <div className="col-md-12 mb-4">
                  <label className="mb-1">Where did you hear about us?</label>
                  <Dropdown className="w-100 border rounded mb-2" drop="up">
                    <Dropdown.Toggle
                      variant="default"
                      id="dropdown-basic"
                      className="w-100 text-start d-flex align-items-center"
                    >
                      {values.referralSource === ""
                        ? "Select Referral Source"
                        : values.referralSource}
                    </Dropdown.Toggle>

                    <Dropdown.Menu className="w-100">
                      {values.referralSource !== "" ? (
                        <Dropdown.Item
                          onClick={() =>
                            formik.setFieldValue("referralSource", "")
                          }
                        >
                          None
                        </Dropdown.Item>
                      ) : null}
                      {referralMenuItems.map((item) => (
                        <Dropdown.Item
                          onClick={() =>
                            formik.setFieldValue("referralSource", item.value)
                          }
                        >
                          {item.text}
                        </Dropdown.Item>
                      ))}
                    </Dropdown.Menu>
                  </Dropdown>
                  {values.referralSource === "OTHER" && (
                    <div>
                      <input
                        className="form-control mt-3"
                        id="otherReferralSource"
                        type="text"
                        placeholder="Referral Source..."
                        value={values.otherReferralSource}
                        onChange={handleChange}
                        onBlur={handleBlur}
                      />
                      {touched.otherReferralSource &&
                      errors.otherReferralSource ? (
                        <div className="text-danger small">
                          {errors.otherReferralSource}
                        </div>
                      ) : null}
                    </div>
                  )}
                </div>
              </div>
              {!hideRechaptcha && <div id="captchaSignup" />}
              <div className="text-center my-3">
                <button
                  className="btn text-white btn-success btn-block mt-3  px-md-5 px-3 fs-5  fw-bold w-100"
                  type="submit"
                  disabled={!isSignUpReCaptchaDone && !hideRechaptcha}
                >
                  {formik.isSubmitting ? (
                    <div class="spinner-border" role="status">
                      <span class="visually-hidden">Loading...</span>
                    </div>
                  ) : (
                    "Create Lender Account"
                  )}
                </button>
              </div>
            </form>
          </div>
          <div className="card-footer text-center">
            <div className="medium text-success fw-bold mb-4">
              <a href={`${process.env.REACT_APP_LOGIN_URL}`}>
                Have an Account? Login!{" "}
              </a>
            </div>
          </div>
        </div>
      ) : selectAccountType === "borrower" ? (
        <div className=" offset-lg-1 col-lg-6 px-md-5 px-3 ">
          <div className=" h-100 d-flex align-items-center">
            <p className=" fs-3 text-muted text-center">
              Borrower accounts must be created by the Lender. Please contact
              your lender and ask them to create you an account!
            </p>
          </div>
        </div>
      ) : (
        <div className="offset-lg-1 col-lg-6 px-md-3 px-3 ">
          <div className="card-body h-100 d-flex align-items-center justify-content-center w-100">
            <div className="w-100">
              <h2 className="text-success text-center primary-green mb-3">
                What kind of account are you looking for?
              </h2>
              <div
                className=" d-flex align-items-center justify-content-center flex-column flex-sm-row"
                style={{ gap: "40px" }}
              >
                <button
                  className="btn btn-success mt-3 px-2 fw-bold w-100"
                  style={{
                    maxWidth: "320px",
                    fontSize: "4rem",
                    lineHeight: "56px",
                  }}
                  onClick={() => {
                    handleAccountType("lender");
                  }}
                >
                  Lender <br />
                  <p
                    className="fs-5"
                    style={{ marginTop: "-8px", marginBottom: "-8px" }}
                  >
                    I want to add my own loans
                  </p>
                </button>
                <button
                  className="btn btn-success btn-block mt-3 px-2 fw-bold w-100"
                  style={{
                    maxWidth: "320px",
                    fontSize: "4rem",
                    lineHeight: "56px",
                  }}
                  onClick={(e) => {
                    handleAccountType("borrower");
                  }}
                >
                  Borrower <br />
                  <p
                    className="fs-5"
                    style={{ marginTop: "-8px", marginBottom: "-8px" }}
                  >
                    {" "}
                    I want to connect to my loan
                  </p>
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      <CustomModal showModal={showPopup} handleClose={handlePopupClose} />
    </div>
  );
}
